/**
 * Where the viewer looks up a project's coordinate system by its EPSG code. Shared by the scene
 * open and the offline capture, which must ask for the same thing.
 */
export function epsgDefinitionUrl(epsg: string, format: "wkt" | "proj4"): string {
    return `https://epsg.io/${epsg}.${format}`;
}
